/**
 * Toont de TeeInBlue-ontwerpafbeelding in een lightbox in plaats van
 * naar de productpagina (drawer) of de kale JPEG (cartpagina) te navigeren.
 *
 * Werkt op twee plekken met verschillende markup:
 *   cartpagina : div.tee-cart-thumbnail > a.tee-cart-thumbnail__link[href=*.jpg] > img
 *   UpCart     : a[href=/products/...] > div.tee-cart-thumbnail > img.tee-cart-thumbnail__img
 *
 * De afbeelding-URL staat al in de DOM (img.src), dus er is geen lookup nodig.
 * Bron is dezelfde flat JPEG van 960x960 die TeeInBlue ook in zijn eigen
 * preview-modal gebruikt: cdn.teeinblue.com/customizations/{id}.jpg
 */
(function () {
  'use strict';

  var CDN_MATCH = 'cdn.teeinblue.com/customizations';
  var box = null;

  function build() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'tib-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Jouw ontwerp');
    // Let op: geen lege <div> als backdrop gebruiken. Dawn's base.css bevat
    // `div:empty { display: none }`, waardoor zo'n element nooit zichtbaar wordt.
    // De verduistering staat daarom op .tib-lightbox zelf.
    box.innerHTML =
      '<div class="tib-lightbox__panel">' +
      '<div class="tib-lightbox__figure">' +
      '<img class="tib-lightbox__img" alt="Jouw ontwerp">' +
      '<button class="tib-lightbox__close" type="button" aria-label="Sluiten">&times;</button>' +
      '</div>' +
      '</div>';
    document.body.appendChild(box);

    box.addEventListener('click', function (e) {
      if (e.target.closest('.tib-lightbox__img')) return; // klik op de foto sluit niet
      close();
    });
    return box;
  }

  function open(url) {
    var el = build();
    el.querySelector('.tib-lightbox__img').src = url;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    var btn = el.querySelector('.tib-lightbox__close');
    if (btn) btn.focus();
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    // src pas leegmaken na de transitie, anders flikkert hij weg
    setTimeout(function () {
      if (box && !box.classList.contains('is-open')) {
        box.querySelector('.tib-lightbox__img').src = '';
      }
    }, 250);
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  function urlFor(node) {
    var img = node.matches('img') ? node : node.querySelector('img');
    if (img && img.src && img.src.indexOf(CDN_MATCH) !== -1) return img.src;

    var link = node.closest('a[href*="' + CDN_MATCH + '"]');
    if (link) return link.href;

    return null;
  }

  // Capture-fase: we moeten voor de click-handler van UpCart zitten,
  // anders navigeert die alsnog naar de productpagina.
  document.addEventListener(
    'click',
    function (e) {
      var thumb = e.target.closest('.tee-cart-thumbnail, .tee-img-link');
      if (!thumb) return;

      var url = urlFor(thumb);
      if (!url) return; // JPEG nog niet klaar; laat het normale gedrag staan

      e.preventDefault();
      e.stopPropagation();
      open(url);
    },
    true
  );
})();
